var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_Master',[_c('main',{staticClass:"content"},[_c('Rankings_Section_Header'),_c('Rankings_Select_Category'),_c('Rankings_List_Posts',{staticClass:"mt-3"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }